import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

angular.module('myConsultApp').directive('redemptionRow', ($ngRedux, $http, ENV, $timeout) => {
  return {
    scope: {
      recordData: '=',
      expandedStatus: '=',
    },
    templateUrl: 'templates/v2/redemption-row.html',
    restrict: 'E',
    link: ($scope, elem) => {
      $scope.shouldBeExpanded = false;
      $scope.record = {};
      $scope.redemptionId =
        $scope.recordData?.redemption_id ||
        $scope.recordData?.redemption?.id ||
        $scope.recordData?.id;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);

      const expandedStatusListerner = $scope.$watch('expandedStatus', (newVal, oldVal) => {
        $scope.shouldBeExpanded =
          newVal || oldVal ? !$scope.shouldBeExpanded : $scope.shouldBeExpanded;
        if ($scope.shouldBeExpanded && !$scope.record?.redemption) {
          $scope.getRedemption($http, ENV, $scope.redemptionId).then((response) => {
            $timeout(() => {
              $scope.record.redemption = response;
            });
          });
        }
      });

      $scope.$on('destroy', () => {
        expandedStatusListerner();
      });
    },
  };
});
